import { getLodop } from "@/utils/LodopFuncs";
import moment from "moment";

export default function printOrder(item) {
  const LODOP = getLodop();
  LODOP.PRINT_INIT("外部检验申请单");
  LODOP.SET_PRINT_PAGESIZE(1, "210mm", "297mm");
  LODOP.SET_PRINT_MODE("FULL_WIDTH_FOR_OVERFLOW", true);
  LODOP.SET_PRINT_MODE("FULL_HEIGHT_FOR_OVERFLOW", true);

  const pageContent = `
<!DOCTYPE html>
<html>
  <body style="height: 297mm; width: 210mm; border: 2px solid">
    <div style="padding: 24px; height: 100%">
      <div style="text-align: center">
        <div style="font-size: 32px; letter-spacing: 4px; font-weight: bold">外部检验申请单</div>
        <div style="font-size: 20px; margin-top: 12px">APPLICATION OF EXTERNAL INSPECTION</div>
      </div>

      <div style="margin-top: 12px">
        <div>项目号</div>
        <div style="margin-top: 8px">
          <span>Project No.</span>
          <div style="display: inline-block; border-bottom: 2px solid; width: 200px">${item.production_order_number}</div>
        </div>
      </div>
      <div style="margin-top: 12px">
        <div>产品工程号</div>
        <div style="margin-top: 8px">
          <span>Product No.</span>
          <div style="display: inline-block; border-bottom: 2px solid; width: 200px"></div>
        </div>
      </div>
      <div style="margin-top: 12px">
        <div>产品序列号</div>
        <div style="margin-top: 8px">
          <span>Serial No.</span>
          <div style="display: inline-block; border-bottom: 2px solid; width: 200px">${item.goods_number}</div>
        </div>
      </div>
      <div style="margin-top: 12px">
        <div>检验节点</div>
        <div style="margin-top: 8px">
          <span>Inspection No.</span>
          <div style="display: inline-block; border-bottom: 2px solid; width: 200px">${item.process_name}</div>
        </div>
      </div>
      <div style="margin-top: 12px">
        <div>自检结论</div>
        <div style="margin-top: 8px">
          <span>Self-test conclusion</span>
          <div style="display: inline-block; border-bottom: 2px solid; width: 200px">${item.inspection_status_display}</div>
        </div>
      </div>

      <div style="margin-top: 100px">
        <div>检查日期</div>
        <div style="margin-top: 8px">
          <span>Inspection date</span>
          <div style="display: inline-block; border-bottom: 2px solid; width: 200px">
            ${moment(item.inspection_time).format("YYYY-MM-DD")}
          </div>
        </div>
      </div>
      <div style="margin-top: 12px">
        <div>申请检查地点</div>
        <div style="margin-top: 8px">
          <span>Place of inspection</span>
          <div style="display: inline-block; border-bottom: 2px solid; width: 100px">&nbsp;</div>
          <span>科邦机械</span>
          <div style="display: inline-block; border-bottom: 2px solid; width: 200px">&nbsp;</div>
        </div>
      </div>
      <div style="margin-top: 12px">
        <div>申请检查项目</div>
        <div style="margin-top: 8px">
          <span>Item of inspection:</span>
        </div>
      </div>
      <div style="margin-top: 12px">
        <div>以上项目 QC 检验合格</div>
        <div style="margin-top: 8px">
          <span>The above item has been inspected by QC and found in goods condition.</span>
        </div>
      </div>

      <div style="width: 40%; margin-top: 12px; padding-left: 60%">检验员 Inspector: ${item.inspector_name}</div>
      <div style="width: 100%; margin: 8px 0; border-bottom: 1px solid"></div>
      <div>
        <span style="letter-spacing: 8px">结论</span>
        <span>Conclusion:</span>
      </div>

      <div style="margin-top: 160px; display: flex">
        <div style="flex: 1; width: 50%">客户方 Customer:</div>
        <div style="flex: 1; width: 50%">RCI:</div>
      </div>

      <div style="margin-top: 12px; display: flex">
        <div style="flex: 1; width: 50%">日期 Date:</div>
        <div style="flex: 1; width: 50%">日期 Date:</div>
      </div>
    </div>
  </body>
</html>
`;

  LODOP.NewPage();
  LODOP.ADD_PRINT_HTM(0, 0, "100%", "100%", pageContent);
  LODOP.PREVIEW();
}
